<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/"><i class="icon-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ transations.accVerification }}
          </li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <div class="page-header">
      <div class="container">
        <h1>{{ transations.accVerification }}</h1>
      </div>
      <!-- End .container -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <section>
            <div class="panel card-sign">
              <div v-if="isValid" class="alert alert-info">
                {{ transations.accVerificationInProgress }}
              </div>
              <div v-else class="alert alert-danger">
                {{translations.verificationLinkHasExpired}}
              </div>
            </div>

            <p class="text-center text-muted mt-3 mb-5">
              Eurosan B2B. &copy; {{ currentYear }}. {{translations.allRightsReserved}}
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'VerifyEmail',
  mixins: [translations],
  data() {
    return {
      isValid: true,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    verifyEmail() {
      const { userId, token } = this.$route.query;

      const payload = {
        userId,
        // Replaces spaces with + character
        token,
      };

      api.verifyEmail(payload).then((response) => {
        this.isValid = response.data.isValid;
        // this.$toast.info(response.data.info);
        this.$router.push({ name: 'Login' });
      }).catch((err) => {
        this.isValid = err.response.data.isValid;
        // this.$toast.error(err.response.data.info);
      });
    },
  },
  mounted() {
    this.verifyEmail();
  },
};
</script>
